import { render, staticRenderFns } from "./FinalizeTask.vue?vue&type=template&id=cdf4d22c&scoped=true&"
import script from "./FinalizeTask.vue?vue&type=script&lang=js&"
export * from "./FinalizeTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf4d22c",
  null
  
)

export default component.exports